<template>
	<view class="success">
		<image src="/static/icon/ic_success@2x.png" mode="widthFix"></image>
		<text class="success-a">供餐认证提交成功</text>
		<text class="success-b">请耐心等待审核</text>
		<view class="success-footer">
			<view class="success-footer-btn">回到首页</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.success {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		image {
			width: 180rpx;
			height: 180rpx;
			margin-top: 180rpx;
			margin-bottom: 40rpx;
		}
		.success-a {
			font-weight: 500;
			font-size: 36rpx;
			color: #111111;
			margin-bottom: 20rpx;
		}
		.success-b {
			font-weight: 400;
			font-size: 26rpx;
			color: #999999;
			margin-bottom: 94rpx;
		}
		.success-footer {
			display: flex;
			align-items: center;
			justify-content: center;
			.success-footer-btn {
				width: 200rpx;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				border-radius: 36rpx;
				border: 1rpx solid #00BC12;
				font-weight: 400;
				font-size: 28rpx;
				color: #00BC12;
			}
		}
	}
</style>
